import { ViewerContext, ViewerContextData } from "@web/contexts/ViewerContext";

import { useContext } from "react";

export function useViewerContext(): ViewerContextData {
  return useContext(ViewerContext);
}
